module.exports = __webpack_public_path__ + "static/media/img-3.f75ab71b.jpg";